import * as ng from 'angular';

ng.module('e360')
   .directive('nvNumeric', numericDirective);

/**
 * Directive to force numeric input on a input[type=text] field, and sets
 * the model value to a `number`.
 *
 * By default the directive allows clearing the contents of the field which
 * results in a null value. Pass a number to `nv-numeric` to use that number
 * instead of null when fields is cleared, e.g.
 *
 * `<input type="text" ng-model="model.non-null-number" nv-numeric="0">`
 */
export function numericDirective():ng.IDirective {
   return {
      require: 'ngModel',
      link: numericDirectiveLink
   };
}

function numericDirectiveLink(
   scope:ng.IScope,
   element:JQuery,
   attrs:ng.IAttributes,
   modelCtrl:ng.INgModelController
) {
   let defaultValue:number = null;

   if (attrs.nvNumeric) {
      defaultValue = Number(attrs.nvNumeric);
   }

   modelCtrl.$parsers.push(parseNumeric);
   modelCtrl.$formatters.push(applyDefault);

   /**
    * Forces input from the DOM element to only include numeric values.
    */
   function parseNumeric(value:string):number {
      // could be a number if model already has a value
      if (ng.isNumber(value)) {
         return value;
      }

      let numValue:string = value ? value.replace(/[^\d]/g,'') : null;

      if (numValue === '' || numValue == null) {
         numValue = defaultValue != null ? defaultValue.toString() : null;
      }

      if (numValue !== value) {
         modelCtrl.$setViewValue(numValue);
         modelCtrl.$render();
      }

      return numValue != null ? Number(numValue) : null;
   }

   /**
    * Catches model values that are null or undefined and applies default.
    */
   function applyDefault(value:any):any {
      if (value == null || ng.isUndefined(value)) {
         return defaultValue;
      }

      return value;
   }
}
